export default "__VITE_ASSET__700f20e4__"